const VehicleProfileView = {
  VEHICLE_OVERVIEW: "VEHICLE_OVERVIEW",
  VEHICLE_EXPENSE_OVERVIEW: "VEHICLE_EXPENSE_OVERVIEW",
  VEHICLE_EXPIRATION_OVERVIEW: "VEHICLE_EXPIRATION_OVERVIEW",
  VEHICLE_INCOME_OVERVIEW: "VEHICLE_INCOME_OVERVIEW"
};

export default VehicleProfileView;
